import { all, fork, put } from 'redux-saga/effects'

import amplitudeInstrumentationSaga from '../amplitude/sagas'

import { alertsSaga } from '../alerts'
import { brokeragesSaga } from '../brokerages'
import { clearanceSaga } from '../clearance'
import { invitesSaga } from '../invites'
import { ratingsSaga } from '../ratings'
import { upsellSaga } from '../upsell'
import { submissionSaga } from '../submissions'
import { uploadWhitelistSaga } from '../uploadWhitelist'
import { userSaga } from '../user'
import { usersSaga } from '../users'
import { underWriterSaga } from '../underwriter'

import { sagas as authSaga } from '../auth/sagas'

import toastSagas from '../toasts/sagas'

import { appInitialized } from '../actions/appActions'

export const rootSaga = function* root(initialState) {
  yield all([
    fork(alertsSaga),
    fork(amplitudeInstrumentationSaga),
    fork(authSaga),
    fork(brokeragesSaga),
    fork(clearanceSaga),
    fork(invitesSaga),
    fork(ratingsSaga),
    fork(submissionSaga),
    fork(upsellSaga),
    fork(toastSagas),
    fork(uploadWhitelistSaga),
    fork(userSaga),
    fork(usersSaga),
    fork(underWriterSaga),
    put(appInitialized(initialState))
  ])
}
